import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { publicRoutes, shellRoutes } from './app.routes';
import { environment } from '../environments/environment';
import {
  provideDarkTheme,
  remoteConfigProviders,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { withLogin } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { einseitigeLagerbuchungProviders } from '@softapps/mde/einseitige-lagerbuchung';
import {
  provideSoftApps,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_PUBLIC,
} from '@softapps/core';
import { gesamtabfrageProviders } from '@softapps/wws/gesamtabfrage';
import { provideGarageOrderModule } from '@softapps/werkstatt/order';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { provideEslLinkProviders } from '@softapps/handel/esl-link';
import { lagerCoreProviders } from '@softapps/lager/core';
import { provideEslConfigModule } from '@softapps/handel/esl-config';
import { provideEslLinkStorageProviders } from '@softapps/handel/esl-link-storage';
import { provideMdeInventoryModule } from '../../../../../../libs/softapps/mde/inventory/src/lib/inventory.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([]),
    provideSoftApps({ connection: environment.connection }, withLogin()),

    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },

    { provide: SOFTLINE_ROUTES_APPS, useValue: shellRoutes, multi: true },
    { provide: SOFTLINE_ROUTES_PUBLIC, useValue: publicRoutes, multi: true },

    ...remoteConfigProviders,

    //Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,
    ...settingsProviders,
    ...moduleProviders,
    ...passwordProviders,

    // MDE
    ...wwsCoreProviders,

    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...provideMdeInventoryModule(),
    ...warenverprobungProviders,
    ...retourenProviders,

    ...artikelInfoProviders,
    ...einseitigeLagerbuchungProviders,

    // Werkstatt
    provideGarageOrderModule(),

    provideStorageLocation(),
    ...gesamtabfrageProviders,

    provideEslConfigModule(),
    provideEslLinkProviders(),
    provideEslLinkStorageProviders(),
    ...lagerCoreProviders,

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
